// extracted by mini-css-extract-plugin
module.exports = {"Guard":"Guard_Guard__38hBT"};